import React, { useCallback } from 'react'
import { GetProps, Input } from 'antd'
import { DigitalAssetListRequestFilter } from '../../../modules/domain/digitalAsset/types'
import { CompanyListRequestFilter } from '../../../modules/domain/company/types'

type SearchProps = GetProps<typeof Input.Search>
const { Search } = Input

type SearchInputFilterProps = SearchProps & {
  filter: DigitalAssetListRequestFilter | CompanyListRequestFilter
  filterUpdated: (filter: DigitalAssetListRequestFilter | CompanyListRequestFilter) => void
}

/*Component that works with selectors and actions defined in redux.

References: {@link DigitalAssetListRequestFilter} , {@link CompanyListRequestFilter}
 * */
const SearchInputFilter: React.FC<SearchInputFilterProps> = ({
  filter,
  filterUpdated,
  placeholder = 'Input search text',
  ...restProps
}) => {
  const handleSearchChange = useCallback(
    (search?: string) => {
      filterUpdated({ ...filter, ...{ search } })
    },
    [filterUpdated, filter],
  )

  const onSearch: SearchProps['onSearch'] = (value, _e, _info) => {
    handleSearchChange(value)
  }

  return <Search placeholder={placeholder} onSearch={onSearch} {...restProps} />
}

export default SearchInputFilter
